import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaCamera } from 'react-icons/fa';

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken, base_url, user_location } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';

const Rmstock = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);

  const [alllocations, setAlllocations] = useState([]);
  const [berriesforyou, setBerriesforyou] = useState([]);
  const [dirafrost, setDirafrost] = useState([]);
  const [mondialberry, setMondialberry] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
    setPermission(FindModuleById(462));
    console.log(permission);

    fetchProductionFeeds();
    fetchGroupedProductionFeeds();
  }, []);

  // Extracted reusable fetch functions
  const fetchProductionFeeds = () => {
    axios.post("/rm-stock/listing", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken } })
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.productions);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      }).catch((error) => {
        console.log(error);
      });
  };

  const fetchGroupedProductionFeeds = () => {
    axios.post("/rm-stock/listing-groupby", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken } })
      .then((response) => {
        if (response.data.code === 200) {
          setAlllocations(response.data.data.all_locations);
          setBerriesforyou(response.data.data.location_Berries_For_You);
          setDirafrost(response.data.data.location_Dirafrost);
          setMondialberry(response.data.data.location_Mondial_Berry);
        }
        else if (response.data.code === 401) {
          window.location.href = "/login";
        } else {
          window.location.href = "/login";
        }
      }).catch((error) => {
        console.log(error);
      });
  };



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/rm-stock/delete/${item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/rm-stock";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  // ✅ Palletisation Cell Component
  const PalletisationCell = ({ row }) => {
    if (row.original.feed_type === 'raw') {
      return <span>{row.original.palletesation_raw_material?.barcode || ''}</span>;
    }

    return null;
  };

  PalletisationCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        feed_type: PropTypes.string.isRequired,
        palletesation_raw_material: PropTypes.shape({
          barcode: PropTypes.string,
        }),

      }).isRequired,
    }).isRequired,
  };

  // ✅ Raw Material / Production Out Cell Component
  const RawMaterialProductionCell = ({ row }) => {
    if (row.original.feed_type === 'raw') {
      return <span>{row.original.palletesation_raw_material?.lot_number || ''}</span>;
    }

    return null;
  };

  RawMaterialProductionCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        feed_type: PropTypes.string.isRequired,
        palletesation_raw_material: PropTypes.shape({
          lot_number: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
  };

  // ✅ Define Columns
  const columns = [
    {
      header: 'Location',
      accessorFn: (row) => `${(row.location_name) ? row.location_name.title : ""} `,
    },
    {
      header: 'Product',
      accessorFn: (row) => `${(row.product_detail) ? row.product_detail.name : ""} `,
    },
    {
      accessorKey: 'product_type',
      header: 'Product Type',
    },
    {
      header: 'Net Weight',

      accessorFn: (row) => {
        if (row.feed_type === 'raw') {
          return row.palletesation_raw_material?.net_weight || '';
        }

        return row.quantity_processed;
      },
    },
    {
      header: 'Palletesation Barcode',
      Cell: (props) => <PalletisationCell {...props} />,
      // Add accessorFn to make searchable
      accessorFn: (row) => {
        if (row.feed_type === 'raw') {
          return row.palletesation_raw_material?.barcode || '';
        }

        return '';
      },
    },

    {
      header: 'Raw Material Lot Number',
      Cell: (props) => <RawMaterialProductionCell {...props} />, // ✅ Use new component
      // Add accessorFn to make searchable
      accessorFn: (row) => {
        if (row.feed_type === 'raw') {
          return row.palletesation_raw_material?.lot_number || '';
        }

        return row.quantity_processed;
      },
    },
    {
      accessorKey: 'shift_date',
      header: 'Shift Date',
    },

    {
      accessorKey: 'shift',
      header: 'Shift',
    },

    {
      header: 'Created By',
      accessorFn: (row) =>
        row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}`.trim() : '',
    },
    {
      header: 'Created At',
      accessorFn: (row) =>
        row.created_at
          ? row.created_at.replace('T', ' ').substring(0, 19)
          : '',
    }

  ];


  const LocationCell = ({ row }) => (
    <a href={`/rm-stock-groupby/${row.original.shift_date}_${row.original.location}_${row.original.shift}`}>
      {row.original.location_name ? row.original.location_name.title : ""}
    </a>
  );

  LocationCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        shift: PropTypes.string.isRequired,
        location: PropTypes.string,
        // shift: PropTypes.string.isRequired,
        location_name: PropTypes.shape({
          title: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
  };


  const ShiftDateCell = ({ row }) => (
    <a href={`/rm-stock-groupby/${row.original.shift_date}_${row.original.location}_${row.original.shift}`}>
      {row.original.shift_date ? row.original.shift_date : ""}
    </a>
  );
  ShiftDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        shift: PropTypes.string.isRequired,
        location: PropTypes.string,
        // shift: PropTypes.string.isRequired,
        location_name: PropTypes.shape({
          title: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
  };




  // ✅ Shift Cell Component
  const ShiftCell = ({ row }) => (
    <a href={`/rm-stock-groupby/${row.original.shift_date}_${row.original.location}_${row.original.shift}`} className="">
      {row.original.shift}
    </a>
  );

  ShiftCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string.isRequired,
        shift: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };

  // ✅ Total Consumption Cell Component
  const TotalConsumptionA = ({ row }) => {
    const weight = parseFloat(row.original.a_sum_net_weight) || 0;
    return <span>{weight.toFixed(2)} (KG)</span>;
  };

  TotalConsumptionA.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        a_sum_net_weight: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };


  // ✅ Total Consumption Cell Component
  const TotalConsumptionB = ({ row }) => {
    const weight = parseFloat(row.original.b_sum_net_weight) || 0;
    return <span>{weight.toFixed(2)} (KG)</span>;
  };

  TotalConsumptionB.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        b_sum_net_weight: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };
  // ✅ Total Consumption Cell Component
  const TotalConsumptionCrumble = ({ row }) => {
    const weight = parseFloat(row.original.crumble_sum_net_weight) || 0;
    return <span>{weight.toFixed(2)} (KG)</span>;
  };

  TotalConsumptionCrumble.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        crumble_sum_net_weight: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };
  const TotalConsumptionPuree = ({ row }) => {
    const weight = parseFloat(row.original.puree_sum_net_weight) || 0;
    return <span>{weight.toFixed(2)} (KG)</span>;
  };

  TotalConsumptionPuree.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        puree_sum_net_weight: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };
  const TotalSemifinish = ({ row }) => {
    const weight = parseFloat(row.original.semifinish_sum_net_weight) || 0;
    return <span>{weight.toFixed(2)} (KG)</span>;
  };

  TotalSemifinish.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        semifinish_sum_net_weight: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };
  // ✅ Total Consumption Cell Component
  const TotalConsumptionCell = ({ row }) => {
    const weight = parseFloat(row.original.sum_net_weight) || 0;
    return <span>{weight.toFixed(2)} (KG)</span>;
  };

  TotalConsumptionCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        sum_net_weight: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };
  // ✅ Define columns
  const columnss = [

    {
      header: 'Shift Date',
      accessorFn: (row) => row.shift_date,
      Cell: (props) => <ShiftDateCell {...props} />, // ✅ Use the new component
    },
    {
      header: 'Location',
      accessorFn: (row) => row.location_name || '',
      Cell: (props) => <LocationCell {...props} />, // ✅ Use the new component
    },
    {
      header: 'Shift',
      accessorFn: (row) => row.shift,
      Cell: (props) => <ShiftCell {...props} />, // ✅ Use the new component
    },
    // {
    //   accessorKey: 'total_feeds',
    //   header: 'Number Of Pallets',
    // },
    {
      header: 'Total Reception',
      Cell: (props) => <TotalConsumptionCell {...props} />, // ✅ Use the new component
    },

    {
      header: 'Grade A',
      Cell: (props) => <TotalConsumptionA {...props} />, // ✅ Use the new component
    },
    {
      header: 'Grade B',
      Cell: (props) => <TotalConsumptionB {...props} />, // ✅ Use the new component
    },

    {
      header: 'Crumble',
      Cell: (props) => <TotalConsumptionCrumble {...props} />, // ✅ Use the new component
    },
    {
      header: 'Puree',
      Cell: (props) => <TotalConsumptionPuree {...props} />, // ✅ Use the new component
    },
    {
      header: 'Semi Finished',
      Cell: (props) => <TotalSemifinish{...props} />, // ✅ Use the new component
    },


  ];


  const downloadExcel = (e) => {
    console.log(e);
    window.open(`${base_url}/rm-stock/list-excel`, '_blank');
  }

  const [scannedBarcode, setScannedBarcode] = useState(''); // State for storing scanned barcode
  const [palletDetails, setPalletDetails] = useState(null); // State for pallet details
  const [isScanning, setIsScanning] = useState(false); // State to control scanner visibility

  // ✅ ENHANCED BarcodeScanner Component
  const BarcodeScanner = ({ onScan, isVisible }) => {
    const [scanning, setScanning] = useState(false);
    const [scanner, setScanner] = useState(null);
    const [scanAttempts, setScanAttempts] = useState(0);
    const [scanStatus, setScanStatus] = useState('');


    // Start scanning process with improved configuration
    const startScan = () => {
      setScanning(true);
      setScanStatus('Initializing camera...');
      setScanAttempts(0);

      // After scanning state is set to true and the reader element is rendered:
      setTimeout(() => {
        const readerElement = document.getElementById('reader');

        if (!readerElement) {
          console.error("Reader element not found");
          setScanStatus('Error: Scanner not found');
          setScanning(false);
          return;
        }

        // Dynamically import Html5Qrcode when needed
        import('html5-qrcode')
          .then(module => {
            try {
              const Html5Qrcode = module.Html5Qrcode;
              // Import the formats correctly
              const { Html5QrcodeSupportedFormats } = module;

              const html5QrCode = new Html5Qrcode("reader");

              // Configuration with improved scanning parameters
              const config = {
                fps: 15,              // Higher frame rate for better capture chances
                qrbox: { width: 250, height: 150 }, // Rectangular box might be better for barcodes
                aspectRatio: 1.0,     // Adjust based on camera and barcode orientation
                formatsToSupport: [   // Support multiple formats for better recognition
                  Html5QrcodeSupportedFormats.EAN_13,
                  Html5QrcodeSupportedFormats.EAN_8,
                  Html5QrcodeSupportedFormats.CODE_39,
                  Html5QrcodeSupportedFormats.CODE_93,
                  Html5QrcodeSupportedFormats.CODE_128,
                  Html5QrcodeSupportedFormats.UPC_A,
                  Html5QrcodeSupportedFormats.UPC_E,
                  Html5QrcodeSupportedFormats.ITF,
                  Html5QrcodeSupportedFormats.QR_CODE  // Include QR code support as well
                ],
                experimentalFeatures: {
                  useBarCodeDetectorIfSupported: true // Use native API if available
                }
              };

              setScanStatus('Camera active. Position barcode in the frame...');

              // Start scanning with enhanced configuration
              html5QrCode.start(
                { facingMode: "environment" },
                config,
                (decodedText) => {
                  // Successful scan
                  setScanStatus('Barcode detected!');
                  onScan(decodedText); // Pass scanned value to parent

                  // Make sure we have a valid scanner before trying to stop
                  if (html5QrCode) {
                    try {
                      html5QrCode.stop()
                        .then(() => {
                          setScanning(false);
                          setScanner(null);
                          setScanStatus('');
                        })
                        .catch(err => {
                          console.error("Error stopping scanner after scan:", err);
                          setScanning(false);
                          setScanner(null);
                          setScanStatus('');
                        });
                    } catch (error) {
                      console.error("Error in scan success callback:", error);
                      setScanning(false);
                      setScanner(null);
                      setScanStatus('');
                    }
                  } else {
                    setScanning(false);
                    setScanner(null);
                    setScanStatus('');
                  }
                },
                (errorMessage) => {
                  console.log(errorMessage);
                  // Track error but don't show to user unless persistent
                  if (scanAttempts % 30 === 0) { // Only update status occasionally
                    setScanStatus('Scanning... Ensure barcode is well-lit and in frame');
                  }
                  setScanAttempts(prev => prev + 1);
                }
              ).then(() => {
                // Scanner started successfully, now save the instance
                setScanner(html5QrCode);
                console.log("Scanner initialized successfully");
              }).catch(err => {
                console.error("Failed to start scanner", err);
                setScanStatus('Failed to start scanner. Please check camera permissions.');
                setScanning(false);
                setScanner(null);
              });
            } catch (error) {
              console.error("Error initializing scanner:", error);
              setScanStatus('Error initializing scanner');
              setScanning(false);
            }
          })
          .catch(err => {
            console.error("Failed to load Html5Qrcode", err);
            setScanStatus('Failed to load scanner library');
            setScanning(false);
          });
      }, 1000); // Small delay to ensure DOM update
    };
    // Stop the scanner safely
    const stopScan = () => {
      setScanStatus('Stopping scanner...');
      if (scanner) {
        try {
          // Check if scanner is running first
          if (scanner.isScanning) {
            scanner.stop()
              .then(() => {
                setScanning(false);
                setScanner(null);
                setScanStatus('');
                setIsScanning(false);

              })
              .catch(err => {
                console.error("Error stopping scanner:", err);
                setScanning(false);
                setScanner(null);
                setScanStatus('');
              });
          } else {
            setScanning(false);
            setScanner(null);
            setScanStatus('');
          }
        } catch (error) {
          console.error("Error in stopScan:", error);
          setScanning(false);
          setScanner(null);
          setScanStatus('');
        }
      } else {
        setScanning(false);
        setScanStatus('');
      }
    };

    // Clean up scanner on component unmount
    useEffect(() => {
      return () => {
        if (scanner) {
          try {
            if (scanner.isScanning) {
              scanner.stop().catch(err => console.error("Error stopping scanner on cleanup:", err));
            }
          } catch (error) {
            console.error("Error in cleanup:", error);
          }
        }
      };
    }, [scanner]);

    // Auto-start scanning when component becomes visible
    useEffect(() => {
      if (isVisible) {
        startScan();
      } else {
        stopScan();
      }
    }, [isVisible]);

    // Only render if isVisible is true
    if (!isVisible) {
      return null;
    }

    return (
      <div>
        {scanning && (
          <div className="mt-3">
            <div id="reader" style={{ width: "300px", margin: "0 auto" }}></div>
            {scanStatus && (
              <div className="text-center mt-2">
                <small className="text-muted">{scanStatus}</small>
              </div>
            )}
            <div className="text-center mt-2">
              <button onClick={stopScan} className="btn btn-danger">
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  BarcodeScanner.propTypes = {
    onScan: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired
  };

  // Function to handle barcode scan
  const handleScan = (barcode) => {
    console.log("Scanned barcode:", barcode);

    // Show processing feedback
    Swal.fire({
      title: 'Processing...',
      text: `Reading barcode: ${barcode}`,
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });

    axios.get(`/rm-stock/scan-barcode/${barcode}`, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken
      },
    })
      .then((response) => {
        console.log(response);
        Swal.close();

        if (response.data.code === 200) {
          Swal.fire(
            barcode,
            response.data.message,
            response.data.data.status === 1 ? 'success' : 'error'
          );

          if (response.data.data.status === 1) {
            fetchProductionFeeds();
            fetchGroupedProductionFeeds();
          }
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.close();

        Swal.fire({
          title: 'Error',
          text: 'Failed to process barcode scan. Please try again.',
          icon: 'error',
          confirmButtonText: 'Try Again',
          showCancelButton: true,
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) {
            // Restart scanning
            setIsScanning(true);
          }
        });
      });

    setScannedBarcode(barcode);

    // Optional: Search for the pallet in the data
    const foundPallet = searchPallet(barcode);
    setPalletDetails(foundPallet);

    // Hide scanner after successful scan
    setIsScanning(false);
  };

  // Function to toggle scanner visibility
  const toggleScanner = () => {
    setIsScanning(prevState => !prevState);
  };

  // Helper function to search for a pallet in the existing data
  const searchPallet = (barcode) => {
    // Search in raw material pallets
    const foundRawPallet = data.find(item =>
      item.feed_type === 'raw' &&
      item.palletesation_raw_material?.barcode === barcode
    );

    if (foundRawPallet) return {
      feed_type: 'Raw Material',
      barcode: foundRawPallet.palletesation_raw_material?.barcode,
      lotNumber: foundRawPallet.palletesation_raw_material?.lot_number,
      date: foundRawPallet.date_time,
      shift: foundRawPallet.shift
    };

    // Search in return pallets
    const foundReturnPallet = data.find(item =>
      item.feed_type === 'return' &&
      item.palletesation_production?.barcode_number === barcode
    );

    if (foundReturnPallet) return {
      type: 'Production Return',
      barcode: foundReturnPallet.palletesation_production?.barcode_number,
      date: foundReturnPallet.date_time,
      shift: foundReturnPallet.shift
    };

    return null; // Not found
  };



  console.log("user_location");
  console.log(user_location);


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={toggleMobileMenu} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Raw Material Stock</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Raw Material Stock</li>
                  </ul>
                </div>
                <div className="col-auto">

                  {permission && permission.add === 1 && (
                    <div>


                      <Link
                        to="/rm-stock-add"
                        className="btn btn-primary me-1"
                      >
                        <i className="fas fa-plus"></i>
                      </Link>
                      <button onClick={toggleScanner} className="btn btn-primary me-1">
                        <FaCamera /> {isScanning ? 'Close Scanner' : 'Scan Barcode'}
                      </button>

                      <button
                        className="btn btn-primary"
                        onClick={() => downloadExcel()}
                      >
                        <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                      </button>
                    </div>

                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                {isScanning && (
                  <div className="card mb-4">
                    <div className="card-body">
                      {/* Enhanced Barcode scanner component */}
                      <BarcodeScanner onScan={handleScan} isVisible={isScanning} />

                      {/* Display scanned barcode result */}
                      {scannedBarcode && !isScanning && (
                        <div className="mt-4" style={{ display: 'none' }}>
                          <div className="alert alert-success">
                            <h4>Scanned Barcode: {scannedBarcode}</h4>
                            {palletDetails && (
                              <div>
                                <p><strong>Type:</strong> {palletDetails.feed_type}</p>
                                {palletDetails.lotNumber && (
                                  <p><strong>Lot Number:</strong> {palletDetails.lotNumber}</p>
                                )}
                                <p><strong>Date:</strong> {palletDetails.date}</p>
                                <p><strong>Shift:</strong> {palletDetails.shift}</p>
                              </div>
                            )}
                            <button
                              className="btn btn-secondary mt-2"
                              onClick={() => {
                                setScannedBarcode('');
                                setPalletDetails(null);
                              }}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <section className="comp-section">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card bg-white">
                        {permission && permission.list === 1 && (
                          <div className="card-body">
                            <ul className="nav nav-tabs nav-tabs-bottom">
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-all" data-bs-toggle="tab"> Stocks</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-groupby" data-bs-toggle="tab"> Group By Shift Date and Location</a>
                              </li>
                              <li className="nav-item">
                                <a className={`nav-link   ${user_location == 4 ? "active" : ""}`} href="#groupby-4" data-bs-toggle="tab">RM Stock: Mondial Berry</a>
                              </li>
                              <li className="nav-item">
                                <a className={`nav-link   ${user_location == 6 ? "active" : ""}`} href="#groupby-6" data-bs-toggle="tab"> RM Stock: Berries For You</a>
                              </li>
                              <li className="nav-item">
                                <a className={`nav-link   ${user_location == 7 ? "active" : ""}`} href="#groupby-7" data-bs-toggle="tab"> RM Stock: Dirafrost</a>
                              </li>

                            </ul>
                            <div className="tab-content">
                              <div className={`tab-pane `} id="listing-groupby">
                                <div className="row" id="listing-followup-groupby">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable
                                            columns={columnss}
                                            data={alllocations}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={`tab-pane   ${user_location == 4 ? " show active " : ""}`} id="groupby-4">
                                <div className="row" id="listing-followup-groupby">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable
                                            columns={columnss}
                                            data={mondialberry}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={`tab-pane   ${user_location == 6 ? " show active " : ""}`} id="groupby-6">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable
                                            columns={columnss}
                                            data={berriesforyou}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={`tab-pane   ${user_location == 7 ? " show active " : ""}`} id="groupby-7">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable
                                            columns={columnss}
                                            data={dirafrost}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="tab-pane" id="listing-all">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable
                                            columns={columns}
                                            data={data}
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                            renderRowActionMenuItems={({ row }) => [

                                              permission?.delete === 1 && (
                                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                  Delete
                                                </MenuItem>
                                              ),
                                            ]}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Rmstock;